import $ from 'jquery';
import Select from 'blocks/select/select';
import Overlay from 'blocks/overlay/overlay';
import _ from 'underscore';


export default class {
	constructor(options) {
		const defaults = {
			el: '#international',
			dom: {
				select: '.js-international-select',
				tiles: '.js-tiles',
				template: '.js-international-template',
				overlay: '.js-overlay'
			},
			classes: {
				state: {
					select: 'b-international_state_select'
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$window = $(window);
		this.preventChange = false;
		return this;
	}

	getDom() {
		const self = this;
		self.$overlay = self.$el.closest(self.options.dom.overlay);
		self.$select = self.$el.find(self.options.dom.select);
		self.$tiles = self.$el.find(self.options.dom.tiles);
		self.$template = self.$el.find(self.options.dom.template);
		this.template = _.template(this.$template.html().trim());
		return self;
	}

	onClose() {
		this.onClear();
		this.$el.removeClass(this.options.classes.state.select);
		return this;
	}

	onClear() {
		$.each(this.select, function (key, select) {
			select.clear();
		});
		this.$el.removeClass(this.options.classes.state.select);
		this.$overlay.data('params', []);
		this.$window.trigger('yota.router.check');
	}


	set(data) {
		this.$tiles.html(this.template(data));
		return this;
	}

	prepareOptions(data) {
		const options = [];
		$.each(data, function (key, item) {
			options.push({
				value: key,
				text: item.name
			});
		});
		return options;
	}

	onSelect(event, data) {
		const self = this;
		const value = data.value;
		if (!self.preventChange) {
			self.preventChange = true;
			$.each(self.select, function (key, select) {
				select.setValue(value);
			});
			self.set(self.data[value]);
			self.$el.addClass(self.options.classes.state.select);
			self.$overlay.data('params', [(data.value.toLowerCase())]);
			self.$window.trigger('yota.router.check');
			setTimeout(function () {
				self.preventChange = false;
			}, 100);
		}

	}

	find(code) {
		const self = this;
		const find = code;
		let search = false;
		$.each(self.selectOptions, function (key, item) {
			if (item.value.toLowerCase() == find) {
				search = item.value;
			}
		});
		return search;
	}

	update() {
		const params = this.$overlay.data('params') || [];
		if (params.length) {
			const value = this.find(params[0]);
			if (value !== false) {
				this.onSelect(false, {value: value});
			}
		}
	}

	activate() {
		const params = this.$overlay.data('params') || [];
		if (params.length) {
			const value = this.find(params[0]);
			if (value !== false) {
				this.onSelect(false, {value: value});
			}
		}
	}

	render() {
		const self = this;
		if (self.$el.length) {
			if (yotaPortlets.international) {
				self.getDom();
				self.data = yotaPortlets.international;
				self.select = [];
				self.selectOptions = self.prepareOptions(self.data);

				const select = new Select({el: self.$select}).render();
				select.setOptions(self.selectOptions);
				self.select.push(select);

				self.$select
					.on('yota.select.change', self.onSelect.bind(self))
					.on('yota.select.clean', self.onClear.bind(self));

				self.overlay = new Overlay({
					el: self.$overlay,
					callback: {
						close: self.onClose.bind(self)
					}
				});

				self.$overlay
					.on('yota.router.update', this.update.bind(this))
					.on('yota.router.activate', this.activate.bind(this))
					.trigger('yota.router.update')
					.trigger('yota.router.activate');



			} else {
				console.error('The International portlet has no data, set data to "yotaPortlets.international"');
			}
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/international/international.js